export default function Comparacao(){
    return <div>Comparação</div>;
}